// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3ZXF2","amount":"Amount_amount__3J6rQ","tip":"Amount_tip__2aMlj","tipHeader":"Amount_tipHeader__3-70F","tipsWrap":"Amount_tipsWrap__15eFM"};